module.exports = __webpack_public_path__ + "img/insta.d559a878.svg";